import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'

Vue.use(VueI18n);

let messages = {
    "en": require("../public/translations/en.json"),
    "hu": require("../public/translations/hu.json")
}

const cookieLangKey = Cookies.get('langKey');
const defaultLangKey = navigator.language? navigator.language.substring(0,2) == "hu" ? "hu" : "en" : "hu";

var i18n = new VueI18n({
    locale: cookieLangKey? cookieLangKey : defaultLangKey,
    fallbackLocale: "hu",
    messages: messages,
    silentTranslationWarn: true
});

i18n.$t = i18n.t;

export default i18n;